// extracted by mini-css-extract-plugin
export var danger = "_38-6";
export var lightPink = "_38-a";
export var medium = "_38-j";
export var nearSquare = "_38-m";
export var neutralBlue = "_38-8";
export var neutralYellow = "_38-7";
export var noCapitalize = "_38-1";
export var normal = "_38-2";
export var pill = "_38-0";
export var primary = "_38-3";
export var primaryLight = "_38-4";
export var shadow = "_38-n";
export var small = "_38-k";
export var solidBlack = "_38-i";
export var solidGreen = "_38-d";
export var solidLightBlue = "_38-f";
export var solidNavy = "_38-e";
export var solidOrange = "_38-h";
export var solidPink = "_38-g";
export var solidRed = "_38-b";
export var solidWhite = "_38-9";
export var solidYellow = "_38-c";
export var success = "_38-5";
export var xsmall = "_38-l";